import { render, staticRenderFns } from "./InboxMemo.vue?vue&type=template&id=4a2f3bd0&"
import script from "./InboxMemo.vue?vue&type=script&lang=js&"
export * from "./InboxMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports